import { TrackClick } from '~/components/TrackEvent';
import { useLinkComponent } from '~/hooks/mobileApp';

import { CategoryMenuImg } from '~/assets/img/category';

export function CategoryMenu() {
  const LinkComponent = useLinkComponent();

  return (
    <LinkComponent href="/category">
      <TrackClick
        name="clicked button in 마켓"
        properties={{ name: 'gnb_category', categoryName: '카테고리' }}
      >
        <div className="flex flex-col items-center justify-between gap-2">
          <img
            src={CategoryMenuImg.src}
            alt="카테고리 메뉴"
            className="size-48"
          />
          <p className="w-full truncate text-center typo-caption100-regular">
            카테고리
          </p>
        </div>
      </TrackClick>
    </LinkComponent>
  );
}
